// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e8edf025","498":"6addbe94","545":"3e35dbb5"}[chunkId] + ".chunk.js";
};